var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21875 1.15625H3.125C3.17656 1.15625 3.21875 1.11406 3.21875 1.0625V1.15625H6.78125V1.0625C6.78125 1.11406 6.82344 1.15625 6.875 1.15625H6.78125V2H7.625V1.0625C7.625 0.648828 7.28867 0.3125 6.875 0.3125H3.125C2.71133 0.3125 2.375 0.648828 2.375 1.0625V2H3.21875V1.15625ZM9.125 2H0.875C0.667578 2 0.5 2.16758 0.5 2.375V2.75C0.5 2.80156 0.542187 2.84375 0.59375 2.84375H1.30156L1.59102 8.97266C1.60977 9.37227 1.94023 9.6875 2.33984 9.6875H7.66016C8.06094 9.6875 8.39023 9.37344 8.40898 8.97266L8.69844 2.84375H9.40625C9.45781 2.84375 9.5 2.80156 9.5 2.75V2.375C9.5 2.16758 9.33242 2 9.125 2ZM7.56992 8.84375H2.43008L2.14648 2.84375H7.85352L7.56992 8.84375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/removeIcon.4d13ae40aae64606e08259eb56264411.svg";
export { ForwardRef as ReactComponent };